import React from 'react'

import { Pagination, UiArrowLeftIcon, UiArrowRightIcon } from '@octane/spark'

import {
    Container,
    SimplePaginationContainer,
    Arrow,
    PageIndicator,
} from './AdaptivePagination.styled'

export interface AdaptivePaginationProps {
    currentPage: number
    pageCount?: number
    hasNextPage: boolean
    disabled?: boolean
    onChangePage: (page: number) => void
}

export default function AdaptivePagination({
    currentPage,
    pageCount,
    hasNextPage,
    disabled = false,
    onChangePage,
}: AdaptivePaginationProps) {
    const iconProps = {
        width: 26,
        height: 30,
    }

    // Legacy mode: page count is known, use numbered pagination
    if (pageCount !== undefined && pageCount > 0) {
        return (
            <Container>
                <Pagination.PaginationBar
                    variant="numbered"
                    currentPage={currentPage}
                    pageCount={pageCount}
                    onChangePage={onChangePage}
                    disabled={disabled}
                />
            </Container>
        )
    }

    // New mode: page count unknown, use simple prev/next pagination
    const isPrevDisabled = currentPage <= 1 || disabled
    const isNextDisabled = !hasNextPage || disabled

    const handlePrevious = () => {
        if (!isPrevDisabled) {
            onChangePage(currentPage - 1)
        }
    }

    const handleNext = () => {
        if (!isNextDisabled) {
            onChangePage(currentPage + 1)
        }
    }

    return (
        <Container>
            <SimplePaginationContainer>
                <Arrow
                    $direction="left"
                    disabled={isPrevDisabled}
                    onClick={handlePrevious}
                    aria-label="Previous page"
                >
                    <UiArrowLeftIcon {...iconProps} />
                </Arrow>
                <PageIndicator>Page {currentPage}</PageIndicator>
                <Arrow
                    $direction="right"
                    disabled={isNextDisabled}
                    onClick={handleNext}
                    aria-label="Next page"
                >
                    <UiArrowRightIcon {...iconProps} />
                </Arrow>
            </SimplePaginationContainer>
        </Container>
    )
}
